@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.stylesButton {
  margin-top: 1px;
}

.stylesXsButton {
  margin-left: 36px;
  width: 209px;
}

.styledDropdownMenu {
  gap: 0;

  @include respond-to('mobile') {
    width: 250px;
    min-width: 250px;
  }

  &.select {
    width: 100%;
    max-width: 100%;
  }
}

.selectWrapper {
  width: 100%;

  [data-input-element] {
    cursor: pointer;
    width: 100%;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  [data-input-wrapper] {
    @include border-radius-r2;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }
}

.optionWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  @include typography-v2-body-sm;
}
